import React, { useState } from "react"
import { TableRow, TableCell, Tooltip, IconButton, Dialog, } from "@material-ui/core"
import { withRouter, browserHistory } from "react-router"
import moment from 'moment'
import EditIcon from "@material-ui/icons/Edit"
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { displayDateFormatShort } from "../../../constants"
const TimeLog = ({params, item, onEdit, onDelete, filter}) => {
  return (
    <TableRow hover tabIndex={-1}>
      <TableCell>
        <div className="multiline-clamp" style={{width:'140px'}}> Test </div>
      </TableCell>
      <TableCell>
        <div className="multiline-clamp" style={{width:'140px'}}> Test </div>
      </TableCell>
      <TableCell>
        <div className="multiline-clamp" style={{width:'140px'}}> Test </div>
      </TableCell>
      <TableCell>
        <div className="multiline-clamp" style={{width:'140px'}}> Test </div>
      </TableCell>
      <TableCell>
        <div className="multiline-clamp" style={{width:'140px'}}> Test </div>
      </TableCell>
      <TableCell>
        <div className="multiline-clamp" style={{width:'140px'}}> Test </div>
      </TableCell>
      <TableCell>
        <div className="multiline-clamp" style={{width:'140px'}}> Test </div>
      </TableCell>
      <TableCell>
        <div className="multiline-clamp" style={{width:'140px'}}> Test </div>
      </TableCell>
      <TableCell align="right">
        <div style={{width:'70px'}}>
          <Tooltip title="View/Edit">
            <IconButton size="small" color="primary">
              <VisibilityIcon color="primary" fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton size="small" color="primary" onClick={onDelete}>
            <DeleteOutlineIcon color='secondary' fontSize="small" variant="outlined" style={{cursor:'pointer'}}/>
            </IconButton>
          </Tooltip>
        </div>
      </TableCell>
    </TableRow>
  )
}
export default withRouter(TimeLog)